import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { MDBModalService } from 'ng-uikit-pro-standard';
import { ModalInfoComponent } from '../modal-info/modal-info.component';
import { guest } from '../_actions/app-flow-state.actions';
import { clearCart } from '../_actions/cart.actions';
import { resetRates } from '../_actions/rates.actions';
import { removeVehicle } from '../_actions/vehicle.actions';
import { resetDealer } from '../_actions/dealer-actions';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SDLogoutGuard implements CanDeactivate<any> {

  constructor(
    private store: Store<{}>,
    private modalService: MDBModalService
  ) {}

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    const appFlowState = sessionStorage.getItem('appFlowState');
    
    // Only intercept if in SDLogout state
    if (appFlowState !== 'SDLogout') {
      return true;
    }

    // Show confirmation modal
    const modalOptions = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      scroll: true,
      ignoreBackdropClick: true,
      class: "modal-dialog-centered",
      containerClass: "",
      animated: true,
      data: {
        title: "Exit Service Drive",
        content: "Are you sure you want to leave? You will be logged out and any items in your cart will be cleared.",
        decisionMode: true,
        confirmButtonText: "Yes, Leave",
        cancelButtonText: "Cancel",
      },
    };

    const modalRef = this.modalService.show(ModalInfoComponent, modalOptions);
    
    return new Promise<boolean>((resolve) => {
      const actionSubscription = modalRef?.content?.action?.subscribe((action: string) => {
        if (action === "confirm") {
          modalRef.hide();
          // Clear cart and related data, then transition to guest state
          this.store.dispatch(clearCart());
          this.store.dispatch(resetRates());
          this.store.dispatch(removeVehicle());
          this.store.dispatch(resetDealer());
          this.store.dispatch(guest());
          actionSubscription.unsubscribe();
          resolve(true);
        } else if (action === "cancel") {
          modalRef.hide();
          actionSubscription.unsubscribe();
          resolve(false);
        }
      });
    });
  }
}
